import { render, staticRenderFns } from "./ListingVideos.vue?vue&type=template&id=635f4f06&"
import script from "./ListingVideos.vue?vue&type=script&lang=js&"
export * from "./ListingVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports